export function checkForInputInteractions() {
  var isMobile = window.matchMedia(
    "only screen and (max-width: 767.98px)",
  ).matches;

  if (isMobile) {
    const header = document.getElementById("big-header-mobile-expanded");
    let lastFocusElement = null;

    // Hide the sticky header when the virtual keyboard is shown
    const checkScreenHeight = () => {
      const visualHeight = window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;

      if (!header) return;

      if (
        visualHeight <= header.offsetHeight * 1.4 &&
        (!document.activeElement ||
          (document.activeElement &&
            document.activeElement.classList.contains("mobile-input")))
      ) {
        header.style.position = "relative";
      } else {
        header.style.position = "";

        // Scroll down based on the active input
        if (lastFocusElement) {
          if (lastFocusElement.scrollIntoView) {
            lastFocusElement.scrollIntoView(false);
            lastFocusElement = null;
          }
        }
      }
    };

    const mobileInputs = document.querySelectorAll("input.mobile-input");
    mobileInputs.forEach((input) => {
      input.addEventListener("focusout", function () {
        lastFocusElement = this;
      });
    });

    if (mobileInputs.length > 0) {
      checkScreenHeight();
      window.visualViewport.addEventListener("resize", checkScreenHeight);
    }
  }
}
